import { render, staticRenderFns } from "./SedeCentral.vue?vue&type=template&id=9999b66c&"
import script from "./SedeCentral.vue?vue&type=script&lang=js&"
export * from "./SedeCentral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports